/* eslint-disable sort-keys */
import * as core from '../../../../../../../core'

import { query } from './explore-updated-org-structure.query'

export const RESOURCE = {
  payload: {
    alias: 'rp:explore',
    content: {
      navigator: core.mosaic.Page.Segment.Navigator.Tabs,
      segments: [
        {
          name: 'Dashboard',
          root: {
            elements: [
              {
                height: 800,
                content: {
                  row: {
                    elements: [
                      {
                        span: 3,
                        content: {
                          widget: {
                            widget: {
                              alias: 'rp.explore.widgets.metrics-report-card',
                            },
                          },
                        },
                      },
                      {
                        span: 8,
                        content: {
                          column: {
                            elements: [
                              {
                                height: 400,
                                content: {
                                  widget: {
                                    widget: {
                                      alias:
                                        'wip.rp-wfuhs.explore.widgets.comparative-performance',
                                    },
                                  },
                                },
                              },
                              {
                                height: 400,
                                content: {
                                  widget: {
                                    widget: {
                                      alias: 'rp.explore.widgets.trends',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                },
              },
            ],
          },
          alias: 'dashboard',
          query: {
            selection: {
              '{}': {
                breadcrumbs: {
                  '[]': [
                    {
                      '{}': {
                        goto: {
                          '{}': {
                            variables: {
                              '{}': {},
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: 'Dashboard',
                      },
                    },
                  ],
                },
              },
            },
          },
        },
        {
          name: 'Organization',
          root: {
            elements: [
              {
                height: 400,
                content: {
                  widget: {
                    widget: {
                      alias: 'rp.explore.widgets.organization-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'org',
          query: {
            selection: {
              '{}': {
                isHidden: {
                  '=': [
                    {
                      '@$': 'orgEntityId',
                    },
                    {
                      '@_': [['dim::!org', 'leaf'], 'id'],
                    },
                  ],
                },
                breadcrumbs: {
                  '++': [
                    {
                      '[]': [
                        {
                          '{}': {
                            goto: {
                              '{}': {
                                segmentId: 'org',
                                variables: {
                                  '{}': {},
                                },
                                navigationId: 'explore',
                              },
                            },
                            name: 'Organization',
                          },
                        },
                      ],
                    },
                    {
                      '??': [
                        {
                          '@': 'breadcrumbs',
                        },
                        {
                          '[]': [],
                        },
                      ],
                    },
                  ],
                },
              },
            },
            subqueries: {
              breadcrumbs: {
                filter: {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'orgRecordId',
                    },
                  ],
                },
                target: 'dim::!org',
                quantity: 1,
                selection: {
                  '++': [
                    {
                      '@': 'ancestors',
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            name: {
                              '@.': '!name',
                            },
                          },
                        },
                      ],
                    },
                  ],
                },
                subqueries: {
                  ancestors: {
                    target: 'ancestors',
                    selection: {
                      '{}': {
                        goto: {
                          '{}': {
                            segmentId: 'org',
                            variables: {
                              '{}': {
                                orgRecordId: {
                                  '@.': '!id',
                                },
                                orgEntityIdSegment: {
                                  '@_': 'id',
                                },
                              },
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: {
                          '@.': '!name',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        {
          name: 'Space',
          root: {
            elements: [
              {
                height: 400,
                content: {
                  widget: {
                    widget: {
                      alias: 'rp.explore.widgets.space-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'space',
          query: {
            selection: {
              '{}': {
                isHidden: {
                  '=': [
                    {
                      '@$': 'spaceEntityId',
                    },
                    {
                      '@_': [['dim::!space', 'leaf'], 'id'],
                    },
                  ],
                },
                breadcrumbs: {
                  '++': [
                    {
                      '[]': [
                        {
                          '{}': {
                            goto: {
                              '{}': {
                                segmentId: 'space',
                                variables: {
                                  '{}': {},
                                },
                                navigationId: 'explore',
                              },
                            },
                            name: 'Space',
                          },
                        },
                      ],
                    },
                    {
                      '??': [
                        {
                          '@': 'breadcrumbs',
                        },
                        {
                          '[]': [],
                        },
                      ],
                    },
                  ],
                },
              },
            },
            subqueries: {
              breadcrumbs: {
                filter: {
                  '=': [
                    {
                      '@.': '!id',
                    },
                    {
                      '@$': 'spaceRecordId',
                    },
                  ],
                },
                target: 'dim::!space',
                quantity: 1,
                selection: {
                  '++': [
                    {
                      '@': 'ancestors',
                    },
                    {
                      '[]': [
                        {
                          '{}': {
                            name: {
                              '@.': '!name',
                            },
                          },
                        },
                      ],
                    },
                  ],
                },
                subqueries: {
                  ancestors: {
                    target: 'ancestors',
                    selection: {
                      '{}': {
                        goto: {
                          '{}': {
                            segmentId: 'space',
                            variables: {
                              '{}': {
                                spaceLevel: {
                                  '@_': ['child', 'name'],
                                },
                                spaceRecordId: {
                                  '@.': '!id',
                                },
                                spaceEntitySegmentId: {
                                  '@_': 'id',
                                },
                              },
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: {
                          '@.': '!name',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        {
          name: 'PI',
          root: {
            elements: [
              {
                height: 400,
                content: {
                  widget: {
                    widget: {
                      alias: 'rp.explore.widgets.pi-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'pi',
          query: {
            selection: {
              '{}': {
                isHidden: {
                  if: [
                    [
                      {
                        '=': [
                          {
                            '@$': 'piHide',
                          },
                          true,
                        ],
                      },
                      true,
                    ],
                    false,
                  ],
                },
                breadcrumbs: {
                  '[]': [
                    {
                      '{}': {
                        goto: {
                          '{}': {
                            variables: {
                              '{}': {},
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: 'PI',
                      },
                    },
                  ],
                },
              },
            },
          },
        },
        {
          name: 'Sponsors',
          root: {
            elements: [
              {
                height: 400,
                content: {
                  widget: {
                    widget: {
                      alias: 'rp.explore.widgets.sponsors-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'sponsors',
          query: {
            selection: {
              '{}': {
                breadcrumbs: {
                  '[]': [
                    {
                      '{}': {
                        goto: {
                          '{}': {
                            variables: {
                              '{}': {},
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: 'Sponsors',
                      },
                    },
                  ],
                },
              },
            },
          },
        },
        {
          name: 'Projects',
          root: {
            elements: [
              {
                height: 400,
                content: {
                  widget: {
                    widget: {
                      alias: 'rp.explore.widgets.projects-table',
                    },
                  },
                },
              },
            ],
          },
          alias: 'projects',
          query: {
            selection: {
              '{}': {
                breadcrumbs: {
                  '[]': [
                    {
                      '{}': {
                        goto: {
                          '{}': {
                            variables: {
                              '{}': {},
                            },
                            navigationId: 'explore',
                          },
                        },
                        name: 'Projects',
                      },
                    },
                  ],
                },
              },
            },
          },
        },
      ],
    },
    description: 'Research Performance Explore Page',
    name: 'rp.explore',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
